export default "__VITE_ASSET__CS0s48Ni__"